import { Link as RouterLink } from 'react-router-dom';
import { uiToneSeverityMap } from '@/theme/uiTokens';
import { Button, Panel, Section, Stack, Text } from '@/ui';
import { Alert, LinearProgress } from '@/ui/primitives';
import { PageShell } from '@/ui/primitives/PageShell';
import type { ReactElement } from 'react';

type SessionExpiredScreenProps = { countdown: number; onRetry: () => void };

export const SessionExpiredScreen = ({
  countdown,
  onRetry,
}: SessionExpiredScreenProps): ReactElement => (
  <PageShell maxWidth="sm" paddingX="lg" paddingY="xl" paddingBottom="xl">
    <Stack gap="lg">
      <Section>
        <Panel
          title="Session expired"
          actions={
            <>
              <Button onClick={onRetry}>Retry</Button>
              <Button component={RouterLink} to="/" variant="secondary">
                Back to sign in
              </Button>
            </>
          }
        >
          <Stack gap="md">
            <Alert severity={uiToneSeverityMap.orange} color="orange" variant="outlined">
              Session expired
            </Alert>
            <Stack gap="xs">
              <Text role="body">Your session has ended. Please sign back in to continue.</Text>
              <Text role="bodyMuted">
                If this keeps happening, check your network connection or contact an administrator.
              </Text>
            </Stack>
            <Text role="caption" color="textSecondary">
              We’ll redirect in {countdown}s
            </Text>
            <LinearProgress
              variant="determinate"
              value={(countdown / 5) * 100}
              aria-label="Session redirect countdown"
            />
          </Stack>
        </Panel>
      </Section>
    </Stack>
  </PageShell>
);
